const PopupPositions = ["Right", "Center", "Left"];
const PopupPositionRight = PopupPositions[0];
const PopupPositionCenter = PopupPositions[1];
const PopupPositionLeft = PopupPositions[2];
const position = [
  "top-start",
  "top",
  "top-end",
  "bottom-start",
  "bottom",
  "bottom-end",
  "left-start",
  "left",
  "left-end",
  "right-start",
  "right",
  "right-end"
];
const setFocus = ["First Actionable", "Container"];
const triggerAction = ["onClick", "onHover"];
const ROLE_REGION = "region";
const TOP = "top";
const BOTTOM = "bottom";
const LEFT = "left";
const RIGHT = "right";
const CENTER = "center";
export {
  BOTTOM,
  CENTER,
  LEFT,
  PopupPositionCenter,
  PopupPositionLeft,
  PopupPositionRight,
  PopupPositions,
  RIGHT,
  ROLE_REGION,
  TOP,
  position,
  setFocus,
  triggerAction
};
